import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {WorkshopInterestSeriesDefinitionList} from './components/WorkshopInterestSeriesDefinitionList';

export function WorkshopInterestSeriesDefinition() {
  return (
    <SettingsTemplate
      header={{
        title: i18n.t('page.workshop.labels.workshopInterestSeriesDefinition'),
        breadcrumbs: [
          {
            label: i18n.t('entity.interest.labels.interest'),
            href: settingsRoutes.workshopInterest,
          },
        ],
      }}
      data-testid="settings-workshop-interest-series-definition"
      description={i18n.t('page.workshop.labels.workshopInterestSeriesDefinitionDescription')}
    >
      <WorkshopInterestSeriesDefinitionList />
    </SettingsTemplate>
  );
}
